import common from "./services/common";

class AppController {
  constructor($timeout, common) {
    this.$timeout = $timeout;
    this.$common = common;
    this.systemUp = true;
    this.checkSystemStatus();
  }

  checkSystemStatus() {
    this.$common.checkSystem().then(({systemUp}) => {

      console.log("system check");
      console.dir(systemUp);

      this.$timeout(() => {
        if (systemUp === true) {
          this.systemUp = true;
        } else {
          this.systemUp = false;
        }
      });
    });
  }

}

AppController.$inject = ["$timeout", "common"];

export default AppController;



// WEBPACK FOOTER //
// ./client/app/app.controller.js